/**
 * Which shell the app draws: the three-column "simple" workspace (default) or
 * the classic workstation with ribbon, menus and tabs. Kept per browser.
 */

import { create } from "zustand";

export type LayoutMode = "simple" | "classic";

const KEY = "ads.layout";

function initial(): LayoutMode {
  try {
    return localStorage.getItem(KEY) === "classic" ? "classic" : "simple";
  } catch {
    return "simple";
  }
}

export const useLayout = create<{ mode: LayoutMode; setMode: (mode: LayoutMode) => void }>((set) => ({
  mode: initial(),
  setMode: (mode) => {
    try {
      localStorage.setItem(KEY, mode);
    } catch {
      // Private window: the choice lasts for this session only.
    }
    set({ mode });
  },
}));
